import gql from 'graphql-tag';

const updateExternalVehiclesLoadMutation = gql`
  mutation updateExternalVehiclesLoad(
    $externalVehicleInput: updateExternalVehiclesLoadInput!
  ) {
    updateExternalVehiclesLoad(input: $externalVehicleInput) {
      success
      errors
    }
  }
`;

export default updateExternalVehiclesLoadMutation;
